import { CompaniesDto, ROUTES } from "../../../../../../shared";
import DialogCustom from "../../../../../DialogCustom/DialogCustom";
import CompanySelectorContent from "../CompanySelectorContent/CompanySelectorContent";

interface IMobileCompanySelectorProps {
  route: ROUTES;
  isOpen: boolean;
  onClose: () => void;
  companies: CompaniesDto[];
}

const MobileCompanySelector = ({
  route,
  isOpen,
  onClose,
  companies,
}: IMobileCompanySelectorProps) => {
  return (
    <DialogCustom
      id="mobile-company-selector"
      closeAfterTransition={false}
      noPadding
      open={isOpen}
      close={onClose}
      data-testid="mobile-company-selector"
    >
      <CompanySelectorContent
        route={route}
        close={onClose}
        companies={companies}
      />
    </DialogCustom>
  );
};

export default MobileCompanySelector;
